// bfsg
// wdv-4095
import * as React from 'react'
import EecTracking from 'theme/atoms/EecTracking'
import styled from 'styled-components'
import theme from 'theme'

import * as t from './types'
import Teaser from './Teaser'
import { ReactComponent as LinkArrow } from 'assets/link-arrow.svg'
import BrandSlider from './BrandSlider'
import Link from 'theme/atoms/Link'
import withDy from './withDy'
import usePersonalization from 'hooks/usePersonalization'

export default withDy(function BrandTeaserListOriginal(props: t.Props) {
  const brands = props.items.map((item, i) => ({
    ...item,
    imgSrc: { ...props.context.optImages[i], src: item.imgSrc }
  }))
  const personalization = usePersonalization()

  return (
    <EecTracking
      config={props.eecTracking}
      gridArea={props.gridArea}
      threshold={1}
    >
      <Wrapper
        data-cy-ctx="organisms/BrandTeaserList"
        $hasLabel={!!(props.label || props.linkLabel)}
      >
        {props.label && (
          <div className="headline" data-cy-state="has-headline">
            <h2 className="title">{props.label}</h2>
            {props.linkLabel && (
              <Link
                to={props.link}
                className="label"
                data-cy-state="has-link-label"
                data-cy-handle="headline-link"
                onClick={() => personalization.trackClick()}
                title={props.linkLabel}
              >
                <div>{props.linkLabel}</div>
                <LinkArrow />
              </Link>
            )}
          </div>
        )}
        {brands.length <= 4 ? (
          <div className="brand-wrapper brandTeaserDesktop" data-cy-state="show-grid-layout">
            {brands.map((item, i) => (
              <div className="teaser-wrapper" key={i}>
                <Teaser
                  tracking={() => personalization.trackClick()}
                  imgSrc={item.imgSrc}
                  name={item.name}
                  to={item.link}
                  style={props.style}
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="BrandTeaserDesktopSlider" data-cy-state="show-desktop-slider">
            <BrandSlider
              listname="Story: BrandTeaserList"
              title={props.label ?? ''}
              brands={brands}
              optImages={props.context.optImages}
              maxProducts={brands.length}
            />
          </div>
        )}
        {brands.length <= 4 && (
          <div className="BrandTeaserMobile" data-cy-state="show-mobile-slider">
            <BrandSlider
              listname="Story: BrandTeaserList"
              title={props.label ?? ''}
              brands={brands}
              optImages={props.context.optImages}
              maxProducts={4}
            />
          </div>
        )}
      </Wrapper>
    </EecTracking>
  )
})

const Wrapper = styled.div<{ $hasLabel: boolean }>`
  width: 100%;
  > .headline {
    display: ${(props) => (props.$hasLabel ? 'flex' : 'none')};
    height: 1.75rem;
    margin-top: ${theme.spacing('ml')};
    justify-content: space-between;
    align-items: center;
    ${theme.ty('rc-2xl', null, 'rc-3xl')}
    margin-bottom: ${theme.spacing('m')};
    > .title {
      ${theme.ty('rc-2xl', null, 'rc-3xl')}
    }
    .label {
      display: flex;
      gap: ${theme.spacing('xs')};
      align-items: center;
      filter: none;
      ${theme.ty('rc-s', 'bold', 'r-base')};
      > svg {
        #Path-5,
        #Path-6 {
        }
        g {
          color: ${theme.colors.b0};
          filter: none;
        }
      }
    }
  }

  > .brand-wrapper {
    display: none;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: ${theme.spacing('s')};
    @media (min-width: ${theme.ms.MD}px) {
      display: grid;
      grid-gap: ${theme.spacing('s')};
    }
    @media (min-width: ${theme.ms.LG}px) {
      grid-gap: ${theme.spacing('m')};
    }
    @media (min-width: ${theme.ms.XL}px) {
      grid-gap: 1rem;
    }
    > .brandTeaserDesktop {
      @media (min-width: ${theme.ms.MD}px) {
        display: block;
        width: 100%;
      }
      @media (min-width: ${theme.ms.XL}px) {
        display: block;
        width: 100%;
      }
    }
  }

  > .BrandTeaserDesktopSlider {
    width: 100%;
    display: block;
    @media (min-width: ${theme.ms.MD}px) {
      display: block;
    }
    
    /* Ensure 4 items are visible across the full width on desktop */
    .BrandSlider .innerSlider > .products > .widget-wrapper {
      @media (min-width: ${theme.ms.MD}px) {
        min-width: calc(25% - ${theme.spacing('xs')});
        flex: 0 0 calc(25% - ${theme.spacing('xs')});
      }
    }
    
    /* Center slider buttons vertically relative to images */
    .BrandSlider .innerSlider {
      @media (min-width: ${theme.ms.MD}px) {
        align-items: center;
        > button {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          z-index: 2;
          &[data-cy-handle="prev-button"] {
            left: -20px;
          }
          &[data-cy-handle="next-button"] {
            right: -20px;
          }
        }
      }
    }
  }

  > .BrandTeaserMobile {
    width: 100%;
    display: block;
    @media (min-width: ${theme.ms.MD}px) {
      display: none;
    }
    @media (min-width: ${theme.ms.XL}px) {
      display: none;
    }
  }
`
